export default __webpack_public_path__ + "static/media/rotate-left.5c727bbf.svg";